import { render, staticRenderFns } from "./SendMail.vue?vue&type=template&id=83b8cdbc&"
import script from "../../models/forget-password/sendmail.ts?vue&type=script&lang=ts&"
export * from "../../models/forget-password/sendmail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports